import React from 'react';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { FormInput } from 'components/molecules/FormInput';

interface IAddPreviousGpListItem {
  index: number;
  arrayName?: string;
  control: any;
  errors: any;
}

const AddPreviousGpListItem = ({
  index,
  arrayName,
  control,
  errors,
}: IAddPreviousGpListItem) => (
  <Box>
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <FormInput
          name={`${arrayName}[${index}].doctorName`}
          label="Name"
          fieldName="doctorName"
          arrayName={arrayName}
          arrayIndex={index}
          control={control}
          errors={errors}
          InputProps={{ readOnly: true }}
        />
      </Grid>
    </Grid>

    <Grid container spacing={1}>
      <Grid item xs={8}>
        <FormInput
          name={`${arrayName}[${index}].doctorAddress`}
          label="Address"
          fieldName="doctorAddress"
          arrayName={arrayName}
          arrayIndex={index}
          control={control}
          errors={errors}
          InputProps={{ readOnly: true }}
        />
      </Grid>
      <Grid item xs={4}>
        <FormInput
          name={`${arrayName}[${index}].doctorPostcode`}
          label="Postcode"
          fieldName="doctorPostcode"
          arrayName={arrayName}
          arrayIndex={index}
          control={control}
          errors={errors}
          InputProps={{ readOnly: true }}
        />
      </Grid>
    </Grid>

    <Grid container spacing={1}>
      <Grid item xs={4}>
        <FormInput
          name={`${arrayName}[${index}].doctorPhone`}
          label="Telephone Number"
          fieldName="doctorPhone"
          arrayName={arrayName}
          arrayIndex={index}
          control={control}
          errors={errors}
          InputProps={{ readOnly: true }}
        />
      </Grid>
      <Grid item xs={4}>
        <FormInput
          name={`${arrayName}[${index}].doctorEmail`}
          label="Email"
          fieldName="doctorEmail"
          arrayName={arrayName}
          arrayIndex={index}
          control={control}
          errors={errors}
          InputProps={{ readOnly: true }}
        />
      </Grid>
    </Grid>
  </Box>
);

export default AddPreviousGpListItem;
